import React from 'react';
import ComingSoon from '../../components/common/ComingSoon';

const icon = <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>;

const Polls = () => (
  <ComingSoon
    title="Anketler"
    description="Sektör anketleri oluşturabileceğiniz ve katılabileceğiniz, topluluk görüşlerini ölçebileceğiniz anket platformu yakında burada."
    icon={icon}
    activeId="feed_poll"
  />
);

export default Polls;
